import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/previous-result", label: "Previous Result" },
  { to: "/common-number", label: "Common Number" },
  { to: "/blog", label: "Blog" },
  { to: "/calendar", label: "Calendar" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export function Logo({ light = false }) {
  return (
    <Link to="/" className="flex items-center gap-2.5 group" data-testid="site-logo">
      <img
        src="/logo.png"
        alt="Guwahati Morning Teer logo"
        className="w-11 h-11 rounded-xl object-cover shadow-md ring-1 ring-black/5"
      />
      <span className={`font-heading font-black text-lg sm:text-xl leading-tight tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
        Guwahati Morning <span className="text-brand">Teer</span>
      </span>
    </Link>
  );
}

export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100" data-testid="site-header">
      <div className="w-full max-w-md mx-auto sm:max-w-xl md:max-w-4xl lg:max-w-6xl px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Logo />
          <nav className="hidden md:flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`nav-desktop-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-lg text-sm font-semibold transition-colors ${
                    isActive ? "text-brand bg-brand-light" : "text-slate-600 hover:text-brand hover:bg-slate-50"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <button
            className="md:hidden flex items-center justify-center w-11 h-11 rounded-xl text-slate-700 hover:bg-slate-100 transition-colors"
            onClick={() => setOpen((o) => !o)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <List className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-100 bg-white animate-fade-in" data-testid="mobile-menu">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-xl text-base font-semibold transition-colors ${
                    isActive ? "text-brand bg-brand-light" : "text-slate-700 hover:bg-slate-50"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
